import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { CommonDataShareService } from "src/app/core/services/common-data-share-service";
import { SubscriptionPlanHandlerService } from "src/app/core/services/subscription-plan-handler.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";

@Component({
  selector: "app-push-notification-listing",
  templateUrl: "./push-notification-listing.component.html",
  styleUrls: ["./push-notification-listing.component.css"],
})
export class PushNotificationListingComponent implements OnInit {
  constructor(
    private _WidgetConfigService: WidgetConfigService,
    private _ActivatedRoute: ActivatedRoute,
    private router: Router,
    private _ApiCallService: ApiCallService,
    private _SubscriptionPlanHandlerService: SubscriptionPlanHandlerService,
    private dataShare: CommonDataShareService
  ) {}
  filter = {
    label: "",
  };
  validWidgets = null;
  finalTemplates = [];
  tab = "STANDARD";
  templateLoading = false;
  tabSelected;
  loading = false;
  selectedTemplate;
  appSubscriptionPlan;
  templateCount;
  typeOfTemplates = [
    {
      displayName: "All Templates",
      type: "ALL",
      optionDisplay: "All",
    },
    {
      displayName: "Preset Templates",
      type: "STANDARD",
      optionDisplay: "Preset",
    },
    {
      displayName: "Custom Templates",
      type: "CUSTOM",
      optionDisplay: "Custom",
    },
  ];
  @ViewChild("search") searchElement: ElementRef;

  ngOnInit(): void {}

  async ngAfterViewInit(): Promise<void> {
    this.getWidgets();
    this.selectList("ALL");
    await this.getTemplates();
  }

  async getTemplates() {
    this.templateLoading = true;
    this.getTemplatesApi().then((result) => {
      console.log(result);
      if (result) {
        this.finalTemplates = result["body"];
        this.getSelectedTemplates();
      }
    });
  }

  async getSelectedTemplates(): Promise<void> {
    this._ActivatedRoute.params.subscribe((param) => {
      if (param.id) {
        this.selectedTemplate = this.finalTemplates.find(
          (x) => x.id == param.id
        );
      } else {
        this.selectedTemplate = this.finalTemplates[0];
      }
      this.templateLoading = false;
    });
  }

  async getWidgets() {
    this.validWidgets = await this._WidgetConfigService.getWidget();
    this.appSubscriptionPlan =
      await this._WidgetConfigService.getAppSubscriptionPlan();
  }

  filterChange(event) {
    if (this.filter.label.length === 0) {
      let interval = setInterval(() => {
        let element = document.getElementById(
          "eTemp-" + this.selectedTemplate["id"]
        );
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          clearInterval(interval);
        }
      });
    }
  }

  searchTemplate() {
    this.templateCount = 0;
    this.finalTemplates.forEach((element) => {
      if (element.layoutName.toLowerCase().includes(this.filter.label))
        this.templateCount++;
    });
  }

  selectList(type) {
    this.tab = type;
    this.tabSelected = this.typeOfTemplates.find((val) => val.type === type);
    this.getTemplates();
  }

  async createStandardTemplate() {
    if (
      await this._SubscriptionPlanHandlerService.IsValidOperation(
        this.appSubscriptionPlan
      )
    ) {
      this.router.navigate([
        "/app//push-notification/creation",
        {
          id: null,
          type: "CUSTOM",
          clone: false,
        },
      ]);
    }
  }

  viewTemplateDetail(layout) {
    this.selectedTemplate = layout;
  }

  editTemplate(template, isClone) {
    this.dataShare.resetPushNotificationTemplateData();
    this.dataShare.setPushNotificationTemplateData(template);
    this.router.navigate([
      "/app/push-notification/creation",
      {
        id: template.id,
        type: "CUSTOM",
        clone: isClone ? true : false,
      },
    ]);
  }

  getTemplatesApi() {
    return new Promise((resolve, reject) => {
      this._ApiCallService.getPushNotificationTemplates(this.tab).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);

          reject(err);
        }
      );
    });
  }
}
